import { mixpanel } from '@fiverr-private/obs';
import { MIXPANEL_EVENT_PROPERTIES, MIXPANEL_PAGE_NAMES } from '../../../../../shared/mixpanel';
import { getDataFromStores } from '../../../../../shared/utils';
import store from '../../store';
import { CardDetails } from '../../types';

export const reportHoverLogo = ({
    logoPosition,
    variationPosition,
    taggedLogoStyles,
    projectId,
    engineType,
    extraEngines,
    algoPool,
    symbolQuality,
    variationsQuality,
    rpi,
}: CardDetails) => {
    mixpanel.track('Logo Maker - Listing - Hover Logo', {
        ...getDataFromStores(
            store.user,
            store.brief,
            store.briefSource,
            store.pagePath,
            store.statistics,
            store.referrer,
            store.fromBoost
        ),
        [MIXPANEL_EVENT_PROPERTIES.PAGE_NAME]: MIXPANEL_PAGE_NAMES.BUYER,
        [MIXPANEL_EVENT_PROPERTIES.VARIATION_POSITION]: variationPosition,
        [MIXPANEL_EVENT_PROPERTIES.LOGO_POSITION]: logoPosition,
        [MIXPANEL_EVENT_PROPERTIES.TAGGED_LOGO_STYLE]: taggedLogoStyles,
        [MIXPANEL_EVENT_PROPERTIES.PROJECT_ID]: projectId,
        [MIXPANEL_EVENT_PROPERTIES.ENGINE_TYPE]: engineType,
        [MIXPANEL_EVENT_PROPERTIES.EXTRA_ENGINES]: extraEngines,
        [MIXPANEL_EVENT_PROPERTIES.ALGO_SOURCE]: algoPool,
        [MIXPANEL_EVENT_PROPERTIES.SYMBOL_QUALITY]: symbolQuality,
        [MIXPANEL_EVENT_PROPERTIES.VARIATIONS_QUALITY]: variationsQuality,
        [MIXPANEL_EVENT_PROPERTIES.RPI]: rpi,
    });
};
